import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-header',
  template: `
    <h1 class="my-2 fs-2">{{title}}</h1>
    <span class="pr-3 ml-auto"></span>
    <ng-content></ng-content>
  `,
  host: {
    'style': 'margin-top: -0.5rem;',
    'class': 'd-flex flex-wrap flex-lg-nowrap flex-grow-0 flex-shrink-0 align-items-center w-100'
  }
})
export class PageHeaderComponent {
  @Input('pageTitle') title: string;
}
